import { SEARCHPROJECT_SUCCESS, SEARCHPROJECT_FAIL, PROJECT_DATA, INVOICE_DATA } from '../actionTypes';

const initialState = {
    user: null,
    projectData: {},
    invoiceData: {},
    invoiceSearch: ""
};

const searchProjectReducer = (state = initialState, action) => {
    switch (action.type) {
        case SEARCHPROJECT_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SEARCHPROJECT_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        case PROJECT_DATA:
            return {
                ...state,
                projectData: action.payload
            }
        case INVOICE_DATA:
            return {
                ...state,
                invoiceData: action.payload
            }
        default:
            break;
    }
    return state;
};

export default searchProjectReducer;
